import { Delete, Edit, Lock } from '@mui/icons-material'
import { styled } from '@mui/material'

export const StyledDeleteIcon = styled(Delete)({
   color: 'grayText',
   '&:hover': {
      cursor: 'pointer',
      color: 'red',
   },
})

export const StyledEditIcon = styled(Edit)(({ theme }) => ({
   color: 'grayText',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.light,
   },
}))

export const StyledLockIcon = styled(Lock)(({ theme }) => ({
   color: 'grayText',
   '&:hover': {
      cursor: 'pointer',
      color: theme.palette.primary.light,
   },
}))
